import { useOffersModules } from "@tm/context-distribution"
import { useQuery } from "react-query"
import { getAdvertisementCategories } from "./getAdvertisementCategories"

export function useAdvertisementCategories(enabled: boolean) {
    const { hasOfferCarouselModuleEnabled } = useOffersModules()

    const { data, isFetching, isFetchedAfterMount } = useQuery("offers_advertisement-categories", () => getAdvertisementCategories(), {
        enabled: enabled && hasOfferCarouselModuleEnabled,
    })
    return {
        advertisementCategories: data?.advertisementCategories,
        advertisementCategoriesLoading: isFetching,
        advertisementCategoriesInitialized: isFetchedAfterMount,
    }
}
